/* CreateSpaceModal.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0NUa3raVF6%7Bmax-height%3A450px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGIZbP%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065UgVvo%7Bpadding-block%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNO7dHp%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bHrqEAEMG%7Bflex-basis%3A0%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r21Y8M%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb8HPE%7Bpadding-right%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW1Y8M%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q8HPE%7Bpadding-left%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r28HPE%7Bpadding-top%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r22ADO%7Bpadding-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAoWWg%7Bmin-height%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaTCo3%7Btransform%3AtranslateY(-1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV0270UD%7Bwidth%3A18px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcav4qQ%7Btransform%3AtranslateY(-2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02uFDC%7Bwidth%3A10px%7D");
import React, { type FormEvent, useCallback, useMemo, useRef, useState } from 'react';
import { useIntl, type IntlShape } from 'react-intl';
import Button from '@atlaskit/button/default/button';
import IconButton from '@atlaskit/button/icon/button';
import type { EmojiId, EmojiProvider } from '@atlaskit/emoji';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import { EmojiPicker } from '@atlaskit/emoji/picker';
import Field from '@atlaskit/form/field';
import Form from '@atlaskit/form/form';
import { RequiredAsterisk } from '@atlaskit/form/required-asterisk';
import Heading from '@atlaskit/heading/heading';
import AddIcon from '@atlaskit/icon/core/add';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import DeleteIcon from '@atlaskit/icon/core/delete';
import EmojiAddIcon from '@atlaskit/icon/core/emoji-add';
import Image from '@atlaskit/image';
import { LinkPicker } from '@atlaskit/link-picker';
import type { LinkPickerProps } from '@atlaskit/link-picker/types';
import { SmartCardProvider } from '@atlaskit/link-provider/smart-card-provider';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalDialog from '@atlaskit/modal-dialog/modal-dialog';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Popup } from '@atlaskit/popup/popup';
import { Box, Flex, Stack, Text } from '@atlaskit/primitives/compiled';
import { SpotlightActions } from '@atlaskit/spotlight/actions';
import { SpotlightBody } from '@atlaskit/spotlight/body';
import { SpotlightCard } from '@atlaskit/spotlight/card';
import { SpotlightControls } from '@atlaskit/spotlight/controls';
import { SpotlightDismissControl } from '@atlaskit/spotlight/dismiss-control';
import { SpotlightFooter } from '@atlaskit/spotlight/footer';
import { SpotlightHeader } from '@atlaskit/spotlight/header';
import { SpotlightHeadline } from '@atlaskit/spotlight/headline';
import { SpotlightMedia } from '@atlaskit/spotlight/media';
import { PopoverContent } from '@atlaskit/spotlight/popover-content';
import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';
import { PopoverTarget } from '@atlaskit/spotlight/popover-target';
import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';
import TextArea from '@atlaskit/textarea/text-area';
import TextField from '@atlaskit/textfield/text-field';
import type { AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service/services/assistance-service/main';
import { Scope } from '@atlassian/link-picker-atlassian-plugin';
import type { AtlassianLinkPickerPluginConfig } from '@atlassian/link-picker-atlassian-plugin/atlassian-link-picker-plugin';
import { useAtlassianPlugins } from '@atlassian/link-picker-atlassian-plugin/use-atlassian-plugins';
const RovoLinkPicker = React.lazy(() => import( /* webpackChunkName: "rovo-link-picker" */
'@atlassian/rovo-link-picker/RovoLinkPicker').then(mod => ({
  default: mod.default
})));
import { type SpaceCreatedFrom, useSpacesAnalytics } from '../../analytics/useSpacesAnalytics';
import { SPACE_ABOUT_MAX_LENGTH, SPACE_NAME_MAX_LENGTH } from '../../common/constants';
import { createEmojiProviderWithUpload as createEmojiProvider } from '../../common/utils/EmojiProviderUtils';
import type { CreateSpaceResponse } from '../../controllers/space-store/types';
import { useAddConversationToSpace } from '../../services/useAddConversationToSpace/useAddConversationToSpace';
import { useCreateSpace } from '../../services/useCreateSpace/useCreateSpace';
import { useDuplicateSourceGuard } from '../source-link-picker/useDuplicateSourceGuard';
// eslint-disable-next-line import/extensions
import firstSpaceOnboardingImageUrl from './assets/first-space-onboarding.png';
import messages from './messages';
import { SmartLinkSourceRow } from './SmartLinkSourceRow';
import { type SpaceSource, type SpaceSourceFormValue, toSpaceSource } from './types';
function useSpaceSourcePlugins(cloudId: string) {
  const configs = useMemo<AtlassianLinkPickerPluginConfig[]>(() => [{
    tabConfig: {
      tabKey: 'confluence',
      tabTitle: 'Confluence'
    },
    products: ['confluence'],
    scope: Scope.ConfluenceContentType,
    cloudId
  }, {
    tabConfig: {
      tabKey: 'jira',
      tabTitle: 'Jira'
    },
    products: ['jira'],
    scope: Scope.JiraIssueDashboardBoardProjectFilter,
    cloudId
  }, {
    tabConfig: {
      tabKey: 'atlas',
      tabTitle: 'Atlas'
    },
    products: ['townsquare'],
    scope: Scope.TownsquareProject,
    cloudId
  }, {
    tabConfig: {
      tabKey: 'loom',
      tabTitle: 'Loom'
    },
    products: ['loom'],
    scope: Scope.Loom,
    cloudId,
    disableActivityClient: true
  }], [cloudId]);
  return useAtlassianPlugins(configs);
}
const styles = {
  rovoLinkPickerWrapper: "_0NUa3raVF6 _2WAcuGIZbP",
  sourceRow: "_4c065UgVvo",
  sourceRowLast: "_4c065UgVvo",
  sourceTitleRow: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
  sourcesContainer: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r21Y8M _1Znuxb8HPE _1wydGW1Y8M _2Zuz6Q8HPE",
  requiredFieldsHint: "_0Of8r28HPE _1wydGW1Y8M",
  iconPickerField: "_0Of8r28HPE",
  descriptionField: "_0Of8r22ADO",
  knowledgeField: "_0Of8r22ADO",
  iconPickerButtonContent: "_4kiQYAoWWg _1VJPcaTCo3",
  iconPickerEmojiSlot: "_39xV0270UD _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
  iconPickerSelectedEmoji: "_1VJPcav4qQ",
  iconPickerChevronSlot: "_39xV02uFDC _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
export type CreateSpacePayload = {
  name: string;
  about: string;
  emoji?: EmojiId;
  sources?: SpaceSource[];
};
export type CreateSpaceModalProps = {
  isOpen: boolean;
  onClose: () => void;
  cloudId: string;
  emojiProvider?: Promise<EmojiProvider>;
  /** When set, source rows show knowledge app icons (same resolver as chat citations). */
  assistanceServiceParams?: AssistanceServiceInputParam['assistanceServiceParams'];
  /** Called after create + (optional) initial-conversation attach. Includes the
   * attached conversation id so callers can update the store optimistically. */
  onCreated?: (space: CreateSpaceResponse, emojiId?: string, attachedConversationId?: string) => void;
  /** Called after validation passes, before the modal closes and form resets (local callback, no BE call) */
  onCreate?: (payload: CreateSpacePayload) => void;
  /** Pre-populate the space name field */
  initialName?: string;
  /** Pre-populate the space description field */
  initialAbout?: string;
  /** Pre-populate the sources list */
  initialSources?: SpaceSource[];
  /** Show the first-space onboarding spotlight anchored to Add sources */
  isFirstSpaceOnboarding?: boolean;
  /** When set, this conversation will automatically be linked to the new space on creation */
  initialConversationId?: string;
  /**
   * Where the create flow was triggered from, for analytics attribution.
   * Defaults to 'manual'.
   */
  createdFrom?: SpaceCreatedFrom;
};
type CreateSpaceFormValues = {
  name: string;
  about: string;
  // Form-only shape: carries `displayText` for the row label override. Stripped
  // to plain `SpaceSource[]` before being handed to BE callers / consumers.
  sources: SpaceSourceFormValue[];
};
const CREATE_SPACE_FORM_ID = 'create-space-form';
const FIRST_SPACE_SPOTLIGHT_OFFSET: [number, number] = [0, 8];
const stopLinkPickerFormSubmit = (event: FormEvent): void => {
  event.preventDefault();
  event.stopPropagation();
};
type SpaceSourcesLayoutProps = {
  sources: SpaceSourceFormValue[];
  onRemove: (ari: string) => void;
  formatMessage: IntlShape['formatMessage'];
  addSourcesTrigger: React.ReactNode;
};
const SpaceSourcesLayout = ({
  sources,
  onRemove,
  formatMessage,
  addSourcesTrigger
}: SpaceSourcesLayoutProps): React.JSX.Element => <Stack space="space.100">
		{sources.length > 0 ? <Box xcss={styles.sourcesContainer}>
				<Stack space="space.0">
					{sources.map((source, index) => <Flex key={source.ari} direction="row" justifyContent="space-between" alignItems="center" xcss={index < sources.length - 1 ? styles.sourceRow : styles.sourceRowLast}>
							<Flex direction="row" alignItems="center" gap="space.100" xcss={styles.sourceTitleRow}>
								<SmartLinkSourceRow url={source.url} fallback={source.name ?? ''} displayTextOverride={source.displayText} />
							</Flex>
							<IconButton icon={DeleteIcon} appearance="subtle" spacing="compact" label={formatMessage(messages.createSpaceRemoveSource, {
          name: source.name
        })} onClick={() => onRemove(source.ari)} testId={`create-space-remove-source-${source.ari}`} />
						</Flex>)}
				</Stack>
			</Box> : null}
		<Text as="p" size="small" color="color.text.subtlest">
			{formatMessage(messages.createSpaceSourcesHelperMessage)}
		</Text>
		<Flex>{addSourcesTrigger}</Flex>
	</Stack>;
type IconPickerFieldProps = {
  isEmojiPickerOpen: boolean;
  onClose: () => void;
  onToggle: () => void;
  emojiProvider: Promise<EmojiProvider>;
  onSelection: (emojiId: EmojiId) => void;
  selectedEmoji: EmojiId | undefined;
  formatMessage: IntlShape['formatMessage'];
};
const IconPickerField = ({
  isEmojiPickerOpen,
  onClose,
  onToggle,
  emojiProvider,
  onSelection,
  selectedEmoji,
  formatMessage
}: IconPickerFieldProps): React.JSX.Element => <Stack space="space.050" xcss={styles.iconPickerField}>
		<Text as="p" size="small" weight="semibold">
			{formatMessage(messages.createSpaceIconLabel)}
		</Text>
		<Popup zIndex={510} isOpen={isEmojiPickerOpen} onClose={onClose} placement="bottom-start" content={() => <EmojiPicker emojiProvider={emojiProvider} onSelection={onSelection} />} trigger={triggerProps => <Flex>
					<Button {...triggerProps} appearance="default" aria-label={formatMessage(messages.createSpaceEmojiPickerLabel)} onClick={onToggle} testId="create-space-emoji-picker-trigger">
						<Flex direction="row" alignItems="center" gap="space.050" xcss={styles.iconPickerButtonContent}>
							<Box xcss={styles.iconPickerEmojiSlot}>
								{selectedEmoji ? <Box xcss={styles.iconPickerSelectedEmoji}>
										<ResourcedEmoji emojiId={selectedEmoji} emojiProvider={emojiProvider} showTooltip fitToHeight={16} />
									</Box> : <EmojiAddIcon label="" />}
							</Box>
							<Box xcss={styles.iconPickerChevronSlot}>
								<ChevronDownIcon label="" size="small" />
							</Box>
						</Flex>
					</Button>
				</Flex>} />
		<Text as="p" size="small" color="color.text.subtlest">
			{formatMessage(messages.createSpaceIconHelperMessage)}
		</Text>
	</Stack>;
type SpaceSourcesFieldBodyProps = {
  fieldProps: {
    value: unknown;
    onChange: (next: SpaceSourceFormValue[]) => void;
  };
  formatMessage: IntlShape['formatMessage'];
  cloudId: string;
  plugins: Parameters<typeof LinkPicker>[0]['plugins'];
  assistanceServiceParams?: CreateSpaceModalProps['assistanceServiceParams'];
  isFirstSpaceOnboarding?: boolean;
};
const SpaceSourcesFieldBody = ({
  fieldProps,
  formatMessage,
  cloudId,
  plugins,
  isFirstSpaceOnboarding = false
}: SpaceSourcesFieldBodyProps): React.JSX.Element => {
  const [isPickerOpen, setPickerOpen] = useState(false);
  const [isFirstSpaceSpotlightVisible, setIsFirstSpaceSpotlightVisible] = useState(isFirstSpaceOnboarding);
  const {
    duplicateSourceFooterError,
    resetDuplicateSourceError,
    submitIfUniqueSource
  } = useDuplicateSourceGuard();
  const sources = (fieldProps.value as SpaceSourceFormValue[] | undefined) ?? [];

  // `fieldProps` is a new object each render from Form; keep a ref so the link-picker callback stays stable.
  const fieldPropsRef = useRef(fieldProps);
  fieldPropsRef.current = fieldProps;
  const handleSubmit: LinkPickerProps['onSubmit'] = useCallback(({
    url,
    displayText,
    title
  }) => {
    const {
      onChange,
      value
    } = fieldPropsRef.current;
    const current = (value as SpaceSourceFormValue[] | undefined) ?? [];
    submitIfUniqueSource(url, current, () => {
      // Treat `displayText` as a user override only when it differs from the
      // link picker's pre-filled `title`; otherwise keep using the live SmartLink title.
      const trimmedDisplayText = displayText?.trim() || undefined;
      const resolvedTitle = title?.trim() || undefined;
      const userDisplayText = trimmedDisplayText && trimmedDisplayText !== resolvedTitle ? trimmedDisplayText : undefined;
      onChange([...current, ({
        ari: url,
        url,
        name: trimmedDisplayText ?? resolvedTitle ?? url,
        displayText: userDisplayText,
        sourceType: detectSourceType(url),
        conversationIds: []
      } satisfies SpaceSourceFormValue)]);
      setPickerOpen(false);
    });
  }, [submitIfUniqueSource]);
  const handleClosePicker = useCallback(() => {
    setPickerOpen(false);
    resetDuplicateSourceError();
  }, [resetDuplicateSourceError]);
  const hideFirstSpaceSpotlight = useCallback(() => {
    setIsFirstSpaceSpotlightVisible(false);
  }, []);
  const addSourcesTriggerButton = <Popup isOpen={isPickerOpen} onClose={handleClosePicker} placement="top-start" zIndex={510} content={() => fg('rovo_spaces_use_rovo_link_picker') ? <React.Suspense fallback={null}>
						<div onSubmit={stopLinkPickerFormSubmit}>
							<Box xcss={styles.rovoLinkPickerWrapper}>
								<RovoLinkPicker cloudId={cloudId} onSubmit={handleSubmit} onCancel={handleClosePicker} footerError={duplicateSourceFooterError} />
							</Box>
						</div>
					</React.Suspense> : <div onSubmit={stopLinkPickerFormSubmit}>
						<LinkPicker plugins={plugins} onSubmit={handleSubmit} onCancel={handleClosePicker} adaptiveHeight recentSearchListSize={3} />
					</div>} trigger={triggerProps => <Button {...triggerProps} appearance="default" iconBefore={AddIcon} type="button" onClick={() => setPickerOpen(prev => !prev)} testId="create-space-add-sources">
					{formatMessage(messages.createSpaceAddSources)}
				</Button>} />;
  const addSourcesTrigger = isFirstSpaceOnboarding ? <PopoverProvider>
			<PopoverTarget>{addSourcesTriggerButton}</PopoverTarget>
			<PopoverContent dismiss={hideFirstSpaceSpotlight} isVisible={isFirstSpaceSpotlightVisible} placement="left-end" offset={FIRST_SPACE_SPOTLIGHT_OFFSET}>
				<SpotlightCard testId="create-space-first-space-onboarding-spotlight">
					<SpotlightHeader>
						<SpotlightHeadline>
							{formatMessage(messages.createSpaceFirstSpaceOnboardingSpotlightTitle)}
						</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl onClick={hideFirstSpaceSpotlight} />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightMedia>
						<Image src={(firstSpaceOnboardingImageUrl as string)} alt="" />
					</SpotlightMedia>
					<SpotlightBody>
						{formatMessage(messages.createSpaceFirstSpaceOnboardingSpotlightDescription)}
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightActions>
							<SpotlightPrimaryAction onClick={hideFirstSpaceSpotlight}>
								{formatMessage(messages.createSpaceFirstSpaceOnboardingSpotlightCta)}
							</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider> : addSourcesTriggerButton;
  return <SpaceSourcesLayout sources={sources} onRemove={ari => fieldProps.onChange(sources.filter(s => s.ari !== ari))} formatMessage={formatMessage} addSourcesTrigger={addSourcesTrigger} />;
};
function detectSourceType(url: string): SpaceSource['sourceType'] {
  if (/confluence/i.test(url)) {
    return 'confluence';
  }
  if (/jira/i.test(url)) {
    return 'jira';
  }
  return 'confluence';
}
const CreateSpaceModalContent = ({
  onClose,
  cloudId,
  emojiProvider,
  assistanceServiceParams,
  onCreate,
  onCreated,
  initialName,
  initialAbout,
  initialSources,
  initialConversationId,
  isFirstSpaceOnboarding = false,
  createdFrom = 'manual'
}: Omit<CreateSpaceModalProps, 'isOpen'>): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const defaultEmojiProvider = useMemo(() => createEmojiProvider(cloudId), [cloudId]);
  const resolvedEmojiProvider = emojiProvider ?? defaultEmojiProvider;
  const [isEmojiPickerOpen, setEmojiPickerOpen] = useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState<EmojiId | undefined>(undefined);
  // Number of sources on the just-submitted form, captured so the
  // space-created event can report `sourceCount` from the async success path.
  const submittedSourceCountRef = useRef(0);
  const {
    fireSpaceCreated,
    fireConversationAdded
  } = useSpacesAnalytics();
  const plugins = useSpaceSourcePlugins(cloudId);
  const nameRequiredMessage = useMemo(() => formatMessage(messages.createSpaceNameRequired), [formatMessage]);
  const handleEmojiSelection = useCallback((emojiId: EmojiId) => {
    setSelectedEmoji(emojiId);
    setEmojiPickerOpen(false);
  }, []);
  const reset = useCallback(() => {
    setEmojiPickerOpen(false);
    setSelectedEmoji(undefined);
  }, []);
  const handleClose = useCallback(() => {
    reset();
    onClose();
  }, [onClose, reset]);
  const {
    addConversation
  } = useAddConversationToSpace({
    cloudId,
    product: assistanceServiceParams?.product ?? 'rovo',
    experienceId: assistanceServiceParams?.experienceId ?? 'ai-mate'
  });
  const handleCreated = useCallback(async (space: CreateSpaceResponse) => {
    fireSpaceCreated({
      spaceId: space?.id,
      sourceCount: submittedSourceCountRef.current,
      hasInitialConversation: Boolean(initialConversationId),
      createdFrom
    });
    let attachedConversationId: string | undefined;
    if (initialConversationId && space?.id) {
      try {
        await addConversation({
          spaceId: space.id,
          conversationId: initialConversationId
        });
        attachedConversationId = initialConversationId;
        fireConversationAdded({
          spaceId: space.id,
          addedFrom: 'createSpace'
        });
      } catch (e) {
        // Surface the failure but don't block closing the modal
        // eslint-disable-next-line no-console
        console.error('[CreateSpaceModal] failed to attach conversation to new space', e);
      }
    }
    // Forward the attached conversation id so callers can stitch it into the optimistic
    // SpaceStore update — the create-space response itself doesn't echo back sources.
    handleClose();
    onCreated?.(space, selectedEmoji?.id, attachedConversationId);
  }, [onCreated, handleClose, selectedEmoji, initialConversationId, addConversation, fireSpaceCreated, fireConversationAdded, createdFrom]);
  const {
    mutate: createSpace,
    isSubmitting
  } = useCreateSpace({
    cloudId,
    product: assistanceServiceParams?.product ?? 'rovo',
    experienceId: assistanceServiceParams?.experienceId ?? 'ai-mate',
    onSuccess: handleCreated
  });
  const handleFormSubmit = useCallback((values: CreateSpaceFormValues) => {
    const trimmed = values.name.trim();
    if (!trimmed) {
      return;
    }

    // Strip client-only `displayText` before handing to BE / consumers (see toSpaceSource).
    const sourcesForSubmission: SpaceSource[] = values.sources.map(toSpaceSource);
    submittedSourceCountRef.current = sourcesForSubmission.length;
    onCreate?.({
      name: trimmed,
      about: values.about.trim(),
      emoji: selectedEmoji,
      sources: sourcesForSubmission
    });
    void createSpace({
      name: trimmed,
      description: values.about.trim() || undefined,
      sources: sourcesForSubmission,
      emoji: selectedEmoji?.id
    });
  }, [createSpace, onCreate, selectedEmoji]);
  return <SmartCardProvider>
			<ModalDialog onClose={handleClose} width="medium" testId="create-space-modal">
				<ModalHeader hasCloseButton>
					{fg('platform_dst_modal-dialog-use-modal-title') ? <ModalTitle>{formatMessage(messages.createSpaceModalTitle)}</ModalTitle> : <Heading size="medium">{formatMessage(messages.createSpaceModalTitle)}</Heading>}
				</ModalHeader>
				<ModalBody>
					<Stack space="space.200">
						<Flex direction="column" gap="space.050">
							<Form<CreateSpaceFormValues> onSubmit={handleFormSubmit}>
								{({
                formProps
              }) => <form {...formProps} id={CREATE_SPACE_FORM_ID} name="create-space">
										<Text as="p">{formatMessage(messages.createSpaceIntro)}</Text>
										<Box xcss={styles.requiredFieldsHint}>
											<Text as="p" aria-hidden="true" size="small" color="color.text.subtlest">
												{formatMessage(messages.createSpaceRequiredFieldsHint, {
                      asterisk: () => <RequiredAsterisk />
                    })}
											</Text>
										</Box>
										<Field name="name" label={formatMessage(messages.createSpaceNameLabel)} isRequired defaultValue={initialName ?? ''} validate={value => value && String(value).trim() ? undefined : nameRequiredMessage} helperMessage={formatMessage(messages.createSpaceNameHelperMessage)} component={({
                  fieldProps
                }) => <TextField {...fieldProps} maxLength={SPACE_NAME_MAX_LENGTH} />} />
										<IconPickerField isEmojiPickerOpen={isEmojiPickerOpen} onClose={() => setEmojiPickerOpen(false)} onToggle={() => setEmojiPickerOpen(!isEmojiPickerOpen)} emojiProvider={resolvedEmojiProvider} onSelection={handleEmojiSelection} selectedEmoji={selectedEmoji} formatMessage={formatMessage} />
										<Box xcss={styles.descriptionField}>
											<Field<string, HTMLTextAreaElement> name="about" label={formatMessage(messages.createSpaceAboutLabel)} defaultValue={initialAbout ?? ''} component={({
                    fieldProps
                  }) => <TextArea {...fieldProps} maxLength={SPACE_ABOUT_MAX_LENGTH} />} />
										</Box>
										<Box xcss={styles.knowledgeField}>
											<Field name="sources" label={formatMessage(messages.createSpaceSourcesLabel)} defaultValue={initialSources ?? []}>
												{({
                      fieldProps
                    }) => <SpaceSourcesFieldBody fieldProps={fieldProps} formatMessage={formatMessage} cloudId={cloudId} plugins={plugins} assistanceServiceParams={assistanceServiceParams} isFirstSpaceOnboarding={isFirstSpaceOnboarding} />}
											</Field>
										</Box>
									</form>}
							</Form>
						</Flex>
					</Stack>
				</ModalBody>
				<ModalFooter>
					<Button appearance="subtle" onClick={handleClose}>
						{formatMessage(messages.createSpaceCancel)}
					</Button>
					<Button appearance="primary" type="submit" form={CREATE_SPACE_FORM_ID} testId="create-space-submit" isDisabled={isSubmitting} isLoading={isSubmitting}>
						{formatMessage(messages.createSpaceSubmit)}
					</Button>
				</ModalFooter>
			</ModalDialog>
		</SmartCardProvider>;
};
export const CreateSpaceModal = ({
  isOpen,
  ...rest
}: CreateSpaceModalProps): React.JSX.Element | null => {
  if (!isOpen) {
    return null;
  }
  return <CreateSpaceModalContent {...rest} />;
};